import { useProfile } from "./index";

const hasOrganisationAccess = (profile) => {
  return (
    profile.admin || profile.roles.find((r) => r.branch_id == null) != null
  );
};

export const hasAccessTo = (profile, branchID, resource, action) => {
  let permission = `${resource}.${action}`;
  if (permission === "diaries_approval.viewer") {
    permission = "gaps.viewer";
  }
  if (permission === "crm.viewer") {
    const crmViewerPermission =
      !profile.admin &&
      profile?.roles &&
      profile.roles[0].permissions.filter(
        (i) => i.includes("crm") && i.includes("viewer")
      )[0];
    permission = crmViewerPermission;
  }
  if (permission === "ok2go.viewer") {
    const ok2goViewerPermission =
      !profile.admin &&
      profile?.roles &&
      profile.roles[0].permissions.filter(
        (i) => i.includes("ok2go") && i.includes("viewer")
      )[0];
    permission = ok2goViewerPermission;
  }

  const allowed = profile.admin
    ? [true]
    : profile?.roles?.filter((r) => {
        if (r.permissions.indexOf(permission) < 0) {
          return false;
        }
        if (r.branch_id !== branchID && r.branch_id != null) {
          return false;
        }
        return true;
      });

  return allowed?.length > 0;
};

const handleBranchRoute = (profile, path) => {
  const branchRouteMatcher = RegExp("/branches/([0-9]+)/([^/]+)").exec(path);

  // if we are checking a branch route
  if (branchRouteMatcher != null && branchRouteMatcher.length === 3) {
    const [p, branchID, resource] = branchRouteMatcher;
    return hasAccessTo(profile, +branchID, resource, "viewer");
  }
  return true;
};

const handleOrganisationRoute = (profile, path) => {
  const orgRouteMatcher = RegExp("/admin/([^/]+)").exec(path);
  // if we are checking an organization route
  if (orgRouteMatcher != null && orgRouteMatcher.length === 2) {
    const [p, resource] = orgRouteMatcher;
    return hasAccessTo(profile, null, resource, "viewer");
  }
  return true;
};

export function usePermission(branchID, resource, action) {
  const profile = useProfile();
  return hasAccessTo(profile, +branchID, resource, action);
}

export const useRoutePermission = (path) => {
  const profile = useProfile();

  if (!handleBranchRoute(profile, path)) {
    return false;
  }
  if (!handleOrganisationRoute(profile, path)) {
    return false;
  }

  return true;
};

export function useAllowedResources(branchID) {
  const profile = useProfile();

  const allowed = {};
  profile.roles.forEach((r) => {
    if (branchID !== r.branch_id && r.branch_id != null) {
      return;
    }
    r.permissions.forEach((p) => {
      const parts = p.split(".");
      parts.pop();
      const resource = parts.join(".");
      allowed[resource] = true;
    });
  });

  let allowedResources = Object.keys(allowed);
  if (allowedResources.some((e) => e.includes("crm"))) {
    allowedResources.push("crm");
  }
  if (allowedResources.some((e) => e.includes("ok2go"))) {
    allowedResources.push("ok2go");
  }
  return allowedResources;
}

export function useOrganizationPermission() {
  const profile = useProfile();
  return hasOrganisationAccess(profile);
}

export function useUserBranches() {
  const profile = useProfile();
  return profile.branches;
}

export function useUserRoleNames() {
  const profile = useProfile();
  return profile.admin ? [] : profile.roles.map((r) => r.role_name);
}

export function useSuperAdmin() {
  const profile = useProfile();
  return profile.admin === true;
}
